<template>
  <div class="stk-p-8">
    <ActionCenter />
  </div>
</template>

<script>
import ActionCenter from '@frontend/ui/features/tasks/components/ActionCenter.vue';

export default {
  name: 'ActionCenterView',
  components: {
    ActionCenter,
  },
};
</script>
